<template>
<div class="page">
    <div class="top-box">
        <img class="mine-bg" :src="Images.img_page_bg1" alt="">
        <div class="top">
            <div @click="goPage" data-url="checkIn">
                <img :src="Images.icon_sign" alt="">
                <p>每日签到</p>
            </div>
            <div @click="goPage" data-url="message">
                <img :src="Images.icon_message" alt="">
                <p>消息</p>
            </div>
        </div>
        <!-- 登录 -->
        <div class="user" v-if="userInfo">
            <img @click="goPage" data-url="userinfo" class="avatar" :src="userInfo.avatar || Images.img_avatar_default_pic" />
            <div>
                <div>
                    <p @click="goPage" data-url="userinfo">{{userInfo.name || '未设置'}}</p>
                    <span @click="_onPressToNavigate('', 'identify')">{{userInfo.is_real_name == 1 ? '已' : '未'}}实名</span>
                </div>
                <div @click="goPage" data-url="userinfo">
                    <div v-if="userInfo.is_company == 1">
                        <img :src="Images.icon_company" alt="">
                        <p>分公司</p>
                    </div>
                    <div v-if="userInfo.is_master == 2">
                        <img :src="Images.icon_user_status2" alt="">
                        <p>传承师</p>
                    </div>
                    <div v-if="userInfo.is_agent == 2">
                        <img :src="Images.icon_user_status1" alt="">
                        <p>代理商</p>
                    </div>
                </div>
                <p>咨询顾问：{{userInfo.agent_name || '未知'}}</p>
            </div>
            <p class="btn-item flex cce" @click="_onPressToNavigate('', 'userinfo')">
                <img class="arrow" :src="Images.icon_arrow_right2" alt="">
            </p>
        </div>
        <!-- 未登录 -->
        <div class="user" v-else @click="_showLoginDialog">
            <img class="avatar" :src="Images.img_avatar_default_pic" alt="">
            <div>
                <div>
                    <p>立即登录</p>
                </div>
            </div>
        </div>
    </div>
    <div class="card order">
        <div class="header">
            <p>我的订单</p>
            <div @click="goPage" data-url="order">
                <p>查看全部</p>
                <img :src="Images.icon_arrow_right1" alt="">
            </div>
        </div>
        <div class="body">
            <div @click="goPage" data-url="order?type=1">
                <img :src="Images.icon_user_nav_1" />
                <p>待付款</p>
                <!-- <span class="num">1</span> -->
            </div>
            <div @click="goPage" data-url="order?type=2">
                <img :src="Images.icon_user_nav_2" />
                <p>待发货</p>
                <!-- <span class="num">1</span> -->
            </div>
            <div @click="goPage" data-url="order?type=3">
                <img :src="Images.icon_user_nav_3" />
                <p>待收货</p>
                <!-- <span class="num">1</span> -->
            </div>
            <div @click="goPage" data-url="order?type=4">
                <img :src="Images.icon_user_nav_4" />
                <p>已完成</p>
                <!-- <span class="num">10</span> -->
            </div>
        </div>
    </div>
    <div class="card" v-for="(item, index) in navArray" :key="index">
        <div class="header">
            <p>{{item.title}}</p>
        </div>
        <div class="body">
            <div v-for="(_item, _index) in item.data" :key="_index" :class="index < 0 && 'order'" @click="goPage" :data-url="_item.link">
                <img :src="_item.icon" alt="">
                <p>{{_item.text}}</p>
            </div>
        </div>
    </div>
    <div class="bottom"></div>
    <Footer :idx="3" />
</div>
</template>

<script>
import { mapGetters } from "vuex";
import Footer from '@/components/Footer'
export default {
    components: {
        'Footer': Footer,
    },
    computed: {
        ...mapGetters(["userInfo"]),
    },
    data() {
        return {
            navArray: [{
                title: '学员专区',
                data: [{
                        icon: this.Images.icon_my_points,
                        text: '我的积分',
                        link: 'myPoints'
                    },
                    {
                        icon: this.Images.icon_mine_logo1_2,
                        text: '我的课程',
                        link: 'myCourse'
                    },
                    {
                        icon: this.Images.icon_mine_logo1_3,
                        text: '我的沙龙',
                        link: `salonList?user_type=${this.Constants.USER_STUDENT}`
                    },
                    {
                        icon: this.Images.icon_mine_logo1_4,
                        text: '义工记录',
                        link: 'volunteers'
                    },
                    {
                        icon: this.Images.icon_mine_logo1_8,
                        text: '积分订单',
                        link: 'pointOrder'
                    },
                    {
                        icon: this.Images.icon_mine_logo1_5,
                        text: '缴费记录',
                        link: 'bill'
                    },
                    {
                        icon: this.Images.icon_mine_logo1_6,
                        text: '收货地址',
                        link: 'address'
                    },
                    {
                        icon: this.Images.icon_mine_logo1_7,
                        text: '每日签到',
                        link: 'checkIn'
                    },
                ]
            }],
            masterMenus: {
                title: '传承师专区',
                data: [{
                        icon: this.Images.icon_mine_logo2_1,
                        text: '传承师信息',
                        link: 'myInheritorInfo'
                    },
                    {
                        icon: this.Images.icon_mine_logo2_3,
                        text: '课程收入',
                        link: `myIncome?user_type=${this.Constants.USER_MASTER}&account_type=${this.Constants.ACCOUNT_CLASS}&pageTitle=课程收入`
                    },
                    {
                        icon: this.Images.icon_mine_logo2_2,
                        text: '我的团队',
                        link: `myInheritorTeam?user_type=${this.Constants.USER_MASTER}&pageTitle=我的传承师团队`
                    },
                    {
                        icon: this.Images.icon_mine_logo2_4,
                        text: '沙龙记录',
                        link: `salonList?user_type=${this.Constants.USER_MASTER}`
                    },
                ]
            },
            agentMenus: {
                title: '代理商专区',
                data: [{
                        icon: this.Images.icon_mine_logo3_1,
                        text: '代理商信息',
                        link: 'myAgentInfo'
                    },
                    {
                        icon: this.Images.icon_mine_logo3_3,
                        text: '商城收入',
                        link: `myIncome?user_type=${this.Constants.USER_AGENT}&account_type=${this.Constants.ACCOUNT_SHOP}&pageTitle=商城收入`
                    },
                    {
                        icon: this.Images.icon_mine_logo3_2,
                        text: '我的团队',
                        link: `myInheritorTeam?user_type=${this.Constants.USER_AGENT}&pageTitle=我的代理商团队`
                    },
                    {
                        icon: this.Images.icon_mine_logo3_4,
                        text: '沙龙记录',
                        link: `salonList?user_type=${this.Constants.USER_AGENT}`
                    },
                    {
                        icon: this.Images.icon_mine_logo3_5,
                        text: '课程记录',
                        link: 'courseRecord'
                    },
                    {
                        icon: this.Images.icon_mine_logo3_3,
                        text: '课程收入',
                        link: `myIncome?user_type=${this.Constants.USER_AGENT}&account_type=${this.Constants.ACCOUNT_CLASS}&pageTitle=课程收入`
                    },
                    {
                        icon: this.Images.icon_mine_logo3_7,
                        text: '我的门票',
                        link: 'myTicket'
                    },
                    {
                        icon: this.Images.icon_mine_logo3_6,
                        text: '我的文章',
                        link: 'myArticle'
                    },
                ]
            },
            otherMenus: {
                title: '其他功能',
                data: [{
                        icon: this.Images.icon_mine_logo4_1,
                        text: '更换手机号',
                        link: 'changeMobile'
                    },
                    {
                        icon: this.Images.icon_mine_logo4_2,
                        text: '修改密码',
                        link: 'changePassword'
                    },
                    {
                        icon: this.Images.icon_mine_logo4_3,
                        text: '常见问题',
                        link: 'question'
                    },
                    {
                        icon: this.Images.icon_mine_logo4_4,
                        text: '联系客服',
                        link: 'contactUs'
                    },
                    {
                        icon: this.Images.icon_mine_logo4_5,
                        text: '关于我们',
                        link: 'aboutUs'
                    },
                    {
                        icon: this.Images.icon_mine_logo4_6,
                        text: '退出登录',
                        link: 'logOut'
                    },
                ]
            },
            applyMasterMenu: {
                icon: this.Images.icon_mine_logo2_1,
                text: '申请传承师',
                link: 'myInheritorInfo'
            },
            applyAgentMenu: {
                icon: this.Images.icon_mine_logo3_1,
                text: '申请代理商',
                link: 'myAgentInfo'
            },
            editUserMenu: {
                icon: this.Images.icon_mine_logo3_6,
                text: '我的文章',
                link: 'myArticle'
            },
        };
    },
    created() {
        this._initialUserMenu();
        console.log('created---->', 'created');
    },
    mounted() {
        console.log('mounted---->', 'mounted');
    },
    methods: {
        _onBack() {
            this.$router.back();
        },

        // 点击跳转
        _onPressToNavigate(pageTitle, path, query) {
            if (pageTitle) {
                query = {
                    ...query,
                    pageTitle,
                }
            }
            this.$router.push({
                path,
                query
            });
        },

        _onPressToWeb(url) {
            if(!url) return;
            window.location.href = url;
        },

        // 跳转
        goPage(e) {

            let token = this.Lockr.get('token')
            console.log('token---->', token);
            if (!token) {
                return this.$emit(this.Constants.SHOWLOGINDIALOG, true);
            }
            
            let {url} = e.currentTarget.dataset

            if((url == 'changeMobile' || url == 'myInheritorInfo' || url == 'myAgentInfo') && !this.userInfo.mobile) {
                console.log('bindMobile---->', 'bindMobile');
                return this.$emit(this.Constants.SHOWBINDMOBILEPOPUP, true);
            }
            
            if (url == 'logOut') {
                this._onPressToLogout();
            } else {
                this.$router.push('/' + url)
            }
        },

        // 顶部Nav的跳转
        onPressNav(router, query = {}) {
            this.$router.push({
                path: '/' + router,
                query: query
            })
        },

        _showLoginDialog() {
            this.$emit(this.Constants.SHOWLOGINDIALOG, true);
        },

        _initialUserMenu() {
            console.log('this.userInfo---->', this.userInfo);
            if (!this.userInfo || !this.userInfo.token) {
                this.otherMenus.data.splice(-1);
            } else {

                if(this.userInfo.is_agent == 2) {
                    this.navArray.push(this.agentMenus);
                } else {
                    this.otherMenus.data.unshift(this.applyAgentMenu);
                }
                
                if(this.userInfo.is_master == 2) {
                    this.navArray.push(this.masterMenus);
                } else {
                    this.otherMenus.data.unshift(this.applyMasterMenu);
                }
                
                if(this.userInfo.is_editor == 1) {
                    this.otherMenus.data.unshift(this.editUserMenu);
                }
            }
            this.navArray.push(this.otherMenus);
        },

        _onPressToLogout() {
            let params = {
                title: '温馨提示',
                message: '确定要退出账号吗？',
            };
            this.AlertManager.confirm(params).then(() => {
                if (!this.$isWeiXin()) {
                    this.$router.replace('/login');
                } else {
                    window.location.reload();
                }
                this.$store.dispatch("LogOut", true);
            });
        }
    },
    beforeRouteLeave (to, from, next) {
        console.log('to, from', to, from)
        // 设置下一个路由的 meta
        if (to.query.pageTitle) {
            to.meta.title = to.query.pageTitle;
        }
        next();
    }
};
</script>

<style lang="less" scoped>
.top-box {
    position: relative;
    padding-bottom: 50px;
}

.mine-bg {
    position: absolute;
    top: 0;
    bottom: 0;
    height: 100%;
    width: 100%;
    object-fit: cover;
}

.top {
    position: relative;
    z-index: 1;
    height: 60px;
    padding: 0px 15px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;

    div {
        display: flex;
        align-items: center;

        img {
            width: 20px;
            height: 20px;
            object-fit: contain;
            margin-right: 5px;
        }

        p {
            font-size: 15px;
            color: #fff;
        }
    }
}

.user {
    position: relative;
    z-index: 1;
    width: 100%;
    padding: 0 15px 5px;
    box-sizing: border-box;
    display: flex;
    align-items: center;

    .avatar {
        width: 68px;
        height: 68px;
        object-fit: cover;
        background: #fff;
        border-radius: 34px;
    }

    >div {
        flex: 1;
        margin: 0 10px;
        overflow: hidden;

        >div {
            margin-bottom: 10px;
            display: flex;
            align-items: center;

            >p {
                font-size: 16px;
                color: #fff;
                margin-right: 5px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }

            >span {
                display: block;
                border-radius: 4px;
                padding: 2px 10px;
                background: #ffffff55;
                font-size: 13px;
                color: #fff;
                white-space: nowrap;
            }

            >div {
                padding: 0 5px;
                margin-right: 5px;
                height: 20px;
                border-radius: 10px;
                background: #fff;
                display: flex;
                align-items: center;

                >img {
                    width: 15px;
                    height: 14px;
                    object-fit: contain;
                    margin-right: 3px;
                }

                >p {
                    font-size: 10px;
                    color: #333;
                }
            }
        }

        >p {
            font-size: 12px;
            color: #fff;
        }
    }

    .btn-item {
        width: 5rem;
        height: 5rem;
        padding-right: 1rem;
        align-items: flex-end;

        .arrow {
            width: 9px;
            height: 16px;
        }
    }
}

.card {
    position: relative;
    z-index: 2;
    background: #fff;
    margin: 10px 15px 0;
    border-radius: 10px;
    box-shadow: 0px 3px 10px 0px rgba(64, 128, 255, 0.10);

    &.order {
        margin-top: -40px;
    }

    .header {
        height: 44px;
        padding: 0 10px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        border-bottom: 1px solid #4080FF11;

        >p {
            flex: 1;
            font-size: 13px;
            color: #333;
            font-weight: 500;
        }

        >div {
            display: flex;
            align-items: center;

            >p {
                font-size: 13px;
                color: #333;
            }

            >img {
                margin-left: 9px;
                width: 8px;
                height: 13px;
            }
        }
    }

    .body {
        display: flex;
        flex-wrap: wrap;
        padding: 5px;

        >div {
            width: 25%;
            height: 60px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            position: relative;

            >img {
                width: 20px;
                height: 20px;
                margin-bottom: 6px;
                object-fit: contain;
            }

            >p {
                font-size: 13px;
                color: #333;
            }

            .num {
                display: flex;
                width: 15px;
                height: 15px;
                border-radius: 50%;
                align-items: center;
                justify-content: center;
                font-size: 10px;
                color: #fff;
                line-height: 1;
                background-color: #ef1400;
                position: absolute;
                top: 5px;
                right: 10px;
                z-index: 1;
            }
        }

        >.order {
            height: 73px;

            >img {
                width: 30px;
                height: 24px;
                margin-bottom: 10px;
            }
        }
    }
}

.bottom {
    height: 30px;
}
</style>
